import apiClient from '@/services/axios'

export async function patch(calenderEntryId, calendarDatesByWeeklyEntry) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries/' + calenderEntryId + '/calendar-dates-by-weekly-interval', calendarDatesByWeeklyEntry);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post section.')
}
